/**
 * One-shot credential handoff between /join and the next page load.
 *
 * /join creates the account, stages {email, password} here and navigates to
 * /dashboard; KeycloakService.init() takes the entry (deleted on first read)
 * and performs the password (ROPC) login. sessionStorage is per-tab and the
 * value never appears in a URL or request log.
 */
const KEY = 'didi.join.pendingLogin';

export interface StagedLogin { u: string; p: string }

export function stageLogin(email: string, password: string): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ u: email, p: password } satisfies StagedLogin));
  } catch {
    // storage unavailable (private mode) → the user simply logs in manually
  }
}

export function takeStagedLogin(): StagedLogin | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    const v = JSON.parse(raw) as { u?: unknown; p?: unknown };
    return typeof v.u === 'string' && typeof v.p === 'string' ? { u: v.u, p: v.p } : null;
  } catch {
    return null;
  }
}
